export interface PhysicalAlbum {
  id: string
  eventId: string
  name: string
  fileLimit?: number | null
  coverPhotoUrl?: string
  date?: string
  fileCount?: number
}

// Used as a placeholder userId for subscription events where the host has no
// stored userId. The backend authorizes these by subscriptionId, but the
// /physical-album/files endpoint parses userId as a UUID before that check, so
// a valid (nil) UUID is required.
export const NIL_UUID = "00000000-0000-0000-0000-000000000000"
